export default __webpack_public_path__ + "static/media/apache-camel-svgrepo-com.3886c1b1.svg";